import React from 'react';

import { Input } from '../shared/Input';
import i18n from '../../config/i18n';

const InputField = ({ field, form, ...restProps }) => (
  <Input {...field} {...restProps} dir={i18n.dir()} />
);

export default React.memo(InputField);
